import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER_URL
})

const install = (Vue) => {
  Vue.prototype.$baseAxios = instance
}

export default {
  install
}